/**
 * The empty list of a History view (Activity, Changes): the list keeps its frame, the bordered box the lanes and the
 * feed (or the change groups) sit in, with a calm empty state centered in it ("All quiet", what would show here, and
 * "Clear filters" while filters are on), instead of a bare line of text next to the filters.
 *
 * Props: { children (what is missing, one sentence), title? ("All quiet"), onClear? (clears the filters: the button
 * shows only with it), testId? }.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Leaf } from '@phosphor-icons/react';
import './Collab.css';

export default function HistoryEmpty({ children, title = 'All quiet', onClear = null, testId = 'history-empty' }) {
  return (
    <div className="collab-empty-frame" data-testid={testId}>
      <div className="collab-empty-state" role="status">
        <span aria-hidden="true" className="collab-empty-icon"><Leaf size={28} weight="duotone" /></span>
        <strong className="collab-empty-title">{title}</strong>
        <p className="collab-empty-text">{children}</p>
        {onClear && (
          <button className="collab-btn collab-empty-clear" data-testid={`${testId}-clear`} onClick={onClear} type="button">Clear filters</button>
        )}
      </div>
    </div>
  );
}

HistoryEmpty.propTypes = {
  children: PropTypes.node.isRequired,
  onClear: PropTypes.func,
  testId: PropTypes.string,
  title: PropTypes.node,
};
